import Import from './action-import'
import Delete from './action-delete'

const Action = {
  Import,
  Delete,
}

export default Action
